



























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import SearchBar from '../components/SearchBar.vue';
// import NewVoteButton from '@/components/next/NewVoteButton.vue';
import NewVoteButton from '../components/VoteButtonNew.vue';
import { Icon, List, Sticky } from 'vant';
import { vote } from '../api';
import qs from 'qs';

Vue.use(Icon)
  .use(List)
  .use(Sticky);
@Component({
  components: {
    SearchBar,
    NewVoteButton,
  },
})
export default class People extends Vue {
  @Prop({ default: 0 }) listNumber!: number;
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  show: boolean = false;
  refreshing: boolean = false;
  search = '';
  placeholder: string = '请输入作品名称或作者';
  voteName: string = '2023project/q3/2023gygg';
  created() {
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
  userInputChange(e: any) {
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
    this.search = e;
    this.page = 1;
    this.list = [];
    this.loading = false;
    this.finished = false;
  }
  onLoad() {
    vote(this.page, this.search, 1).then((res: any) => {
      console.log('res213:', res);
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  votSuccess(data: any, index: any) {
    this.list[index].votes = data;
  }
  onNavTo(url: string, id: number, index: number, type: number) {
    this.$routerThen
      .push({
        url: `${url}?id=${id}&type=${type}`,
      })
      .then((vm) => {
        vm.$on('like', (val: any) => {
          this.list[index].votes++;
        });
      });
  }
}
